import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TranslationsKeys } from '../../../locales/translations';
import { AcademicOfferCreateForm } from './parts/AcademicOfferCreateForm';
import { AcademicOfferDataLoader } from './hooks/AcademicOfferDataLoader';
import { AcademicOfferFormDataLoader } from './hooks/AcademicOfferFormDataLoader';
import { ContinuousEducationType } from './types';

export function AcademicOfferCreate() {
  const { t } = useTranslation(
    TranslationsKeys.CONTINUOUS_EDUCATION_ACADEMIC_OFFERS,
  );

  const programTypeOptions = useMemo(
    () => [
      {
        label: t('form.programType.course'),
        value: ContinuousEducationType.COURSE,
      },
      {
        label: t('form.programType.program'),
        value: ContinuousEducationType.PROGRAM_COURSE,
      },
    ],
    [t],
  );

  return (
    <AcademicOfferFormDataLoader fetchImmediately>
      <AcademicOfferDataLoader programTypeOptions={programTypeOptions}>
        {(initialValues) => (
          <AcademicOfferCreateForm initialValues={initialValues} />
        )}
      </AcademicOfferDataLoader>
    </AcademicOfferFormDataLoader>
  );
}
